import React from "react";
import { Navbar, NavDropdown } from "react-bootstrap";
import NavBarNotifications from "./elements/NavBarNotifications";
import NavBarSearchDropDown from "./elements/NavBarSearchDropdown";
import { gettext } from "../../shared/utils/legacy";
import cropr from "../../shared/utils/cropr";
import NavBarAvatar from "./elements/NavBarAvatar";
import NavBarApps from "./elements/NavBarApps";
import NavBarTrial from "./elements/NavBarTrial";
import useCroprBackbone from "../../shared/hooks/useCroprBackbone";
import { useForceUpdateOnCroprEvent } from "../aside/hooks";
import "./__navbar.scss";
import "./../../shared/buttons/__button.scss";

type NavBarProps = {
  children: React.ReactNode;
};

const NavBar = ({ children }: NavBarProps) => {
  const { permissions, user } = useForceUpdateOnCroprEvent("init");
  const plan = cropr.getActivePlan();
  const [plans] = useCroprBackbone("plans") || [];

  const navApplicationsInstalled = cropr.nav_applications_installed || [];
  const navApplicationsOther = cropr.nav_applications_other || [];
  const farms = cropr.farm_list || [];
  const farm = cropr.farm;
  const activeOrder = cropr.active_order;

  if (farm && !farms[farm.id]) {
    farms[farm.id] = farm.name || farm.get("name");
  }

  return (
    <Navbar sticky={"top"} className={"c-navbar"}>
      <button className="btn navbar-hamburger p-2 pl-1 pr-3 text-slate-light">
        <i className="far fa-bars" />
      </button>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon" />
      </button>
      {permissions && (
        <div className={"collapse navbar-collapse"} id={"navbarSupportedContent"}>
          <ul className={"navbar-nav ml-auto"}>
            <NavBarSearchDropDown
              label={gettext("Farm")}
              active={String(farm.id)}
              onClick={(id) => cropr.setFarm(parseInt(id))}
              data={farms && Object.entries(farms).sort((a, b) => a[1].localeCompare(b[1]))}
            >
              <NavDropdown.Divider />
              {permissions.plan.update && (
                <NavDropdown.Item href="/cropr/settings/farm/">
                  {gettext("Manage farm")}
                </NavDropdown.Item>
              )}
            </NavBarSearchDropDown>

            <NavBarSearchDropDown
              label={gettext("Plan")}
              active={plan.id}
              onClick={(id) => cropr.setPlan(parseInt(id))}
              data={plans.map((plan: any) => [plan.id, plan.name])}
            >
              <NavDropdown.Divider />
              {permissions.plan.update && (
                <NavDropdown.Item href="/cropr/settings/plans/">
                  {gettext("Manage field plans")}
                </NavDropdown.Item>
              )}
            </NavBarSearchDropDown>
            <NavBarApps
              title={"Apps"}
              onClick={(id) => cropr.setActivePlan(parseInt(id))}
              navApplicationsInstalled={navApplicationsInstalled}
              navApplicationsOther={navApplicationsOther}
              permission={permissions.plan.update}
            />
            <NavBarTrial show={activeOrder && !activeOrder.number_of_active_subscription_history} />
            <NavBarNotifications count={0} />
            <NavBarAvatar user={user} />
          </ul>
        </div>
      )}
    </Navbar>
  );
};

export default NavBar;
